import { useQueryClient } from '@tanstack/react-query'

export const usePaymentMethodRefetch = patientId => {
  const queryClient = useQueryClient()

  const refetchPaymentMethodQueries = () => {
    // Invalidate and refetch queries to update the UI
    queryClient.invalidateQueries({
      queryKey: ['PatientFinanceInfo', patientId],
    })
    queryClient.invalidateQueries({
      queryKey: ['PatientFinancePaymentMethods', patientId],
    })
    queryClient.invalidateQueries({
      queryKey: ['PaymentPlans', patientId],
    })

    queryClient.refetchQueries({
      queryKey: ['PatientFinanceInfo', patientId],
    })
    queryClient.refetchQueries({
      queryKey: ['PatientFinancePaymentMethods', patientId],
    })
    queryClient.refetchQueries({
      queryKey: ['PaymentPlans', patientId],
    })
  }

  return { refetchPaymentMethodQueries }
}
